<template>
  <div
    class="fixed top-12 right-4 flex items-center flex-col min-w-[316px] z-[60]"
    v-if="this.toasts.length > 0"
  >
    <Toast v-for="toast in toasts" :key="toast.key" :toast="toast" />
  </div>
</template>

<script>
import Toast from "@/components/toast/Toast.vue";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Toasts",
  components: { Toast },
  computed: {
    toasts() {
      return this.$store.state.toast.toasts;
    },
  },
};
</script>

<style scoped></style>
